import React from 'react';
import {ConnectedRouter} from "connected-react-router";
import {Router} from "react-router-dom";
import history from "./history";
import 'antd/lib/col/style/css';
import AppContainer from './AppContainer';


export default () => {
  
  return (
    <ConnectedRouter history={history}>
      <Router history={history}>
        <AppContainer/>
      </Router>
    </ConnectedRouter>
  );
  
}